var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('resource',{attrs:{"title":"Ändern","resource":"gift","resourceName":"Geschenk","withFiles":true,"original":_vm.original,"attributes":[
      {
        name: 'title',
        label: 'Name'
      },
      {
        name: 'gift_category_id',
        label: 'Kategorie',
        type: 'DropdownResourceSelector',
        resource: 'giftCategory',
        nullValue: 'Keine Kategorie (Allgemein)',
        filter: [
          {
            name: 'sort',
            mode: 'ASC',
            attribute: 'name'
          },
          {
            name: 'forSelect'
          }
        ]
      },
      {
        name: 'price',
        label: 'Preis'
      },
      {
        name: 'royalty',
        label: 'Mod Preis'
      },
      {
        name: 'id',
        label: 'Bild',
        type: 'ImageSelector',
        updateMode: true
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Geschenk bearbeiten")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }